import { render, staticRenderFns } from "./q-label.vue?vue&type=template&id=d2aa6cbc&scoped=true"
import script from "./q-label.vue?vue&type=script&lang=js"
export * from "./q-label.vue?vue&type=script&lang=js"
import style0 from "./q-label.vue?vue&type=style&index=0&id=d2aa6cbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2aa6cbc",
  null
  
)

export default component.exports